import { jsxs as e, jsx as o } from "react/jsx-runtime";
const s = (r) => /* @__PURE__ */ e(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 420 420",
    ...r,
    children: [
      /* @__PURE__ */ e("defs", { children: [
        /* @__PURE__ */ e(
          "linearGradient",
          {
            id: "one-colored_svg__d",
            x1: "50%",
            x2: "50%",
            y1: "0%",
            y2: "100%",
            children: [
              /* @__PURE__ */ o("stop", { offset: "0%", stopColor: "#CDEAFF" }),
              /* @__PURE__ */ o("stop", { offset: "50.5%", stopColor: "#E0BAFF" }),
              /* @__PURE__ */ o("stop", { offset: "100%", stopColor: "#4E36E7" })
            ]
          }
        ),
        /* @__PURE__ */ e(
          "linearGradient",
          {
            id: "one-colored_svg__f",
            x1: "50%",
            x2: "50%",
            y1: "0%",
            y2: "84.185%",
            children: [
              /* @__PURE__ */ o("stop", { offset: "0%", stopColor: "#FFF" }),
              /* @__PURE__ */ o("stop", { offset: "100%", stopColor: "#FFF", stopOpacity: 0 })
            ]
          }
        ),
        /* @__PURE__ */ e(
          "filter",
          {
            id: "one-colored_svg__b",
            width: "344.4%",
            height: "191.7%",
            x: "-122.2%",
            y: "-41.7%",
            filterUnits: "objectBoundingBox",
            children: [
              /* @__PURE__ */ o(
                "feMorphology",
                {
                  in: "SourceAlpha",
                  operator: "dilate",
                  radius: 15,
                  result: "shadowSpreadOuter1"
                }
              ),
              /* @__PURE__ */ o("feOffset", { dy: 10, in: "shadowSpreadOuter1", result: "shadowOffsetOuter1" }),
              /* @__PURE__ */ o(
                "feGaussianBlur",
                {
                  in: "shadowOffsetOuter1",
                  result: "shadowBlurOuter1",
                  stdDeviation: 20
                }
              ),
              /* @__PURE__ */ o(
                "feColorMatrix",
                {
                  in: "shadowBlurOuter1",
                  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ e(
          "filter",
          {
            id: "one-colored_svg__e",
            width: "333.3%",
            height: "187.5%",
            x: "-116.7%",
            y: "-39.6%",
            filterUnits: "objectBoundingBox",
            children: [
              /* @__PURE__ */ o(
                "feGaussianBlur",
                {
                  in: "SourceAlpha",
                  result: "shadowBlurInner1",
                  stdDeviation: 20
                }
              ),
              /* @__PURE__ */ o("feOffset", { dy: 30, in: "shadowBlurInner1", result: "shadowOffsetInner1" }),
              /* @__PURE__ */ o(
                "feComposite",
                {
                  in: "shadowOffsetInner1",
                  in2: "SourceAlpha",
                  k2: -1,
                  k3: 1,
                  operator: "arithmetic",
                  result: "shadowInnerInner1"
                }
              ),
              /* @__PURE__ */ o(
                "feColorMatrix",
                {
                  in: "shadowInnerInner1",
                  values: "0 0 0 0 0.28627451 0 0 0 0 0.470588235 0 0 0 0 0.91372549 0 0 0 1 0"
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ e(
          "radialGradient",
          {
            id: "one-colored_svg__a",
            cx: "58.065%",
            cy: "42.742%",
            r: "58.827%",
            fx: "58.065%",
            fy: "42.742%",
            children: [
              /* @__PURE__ */ o("stop", { offset: "0%", stopColor: "#37343F" }),
              /* @__PURE__ */ o("stop", { offset: "100%", stopColor: "#1E2125" })
            ]
          }
        ),
        /* @__PURE__ */ o(
          "rect",
          {
            id: "one-colored_svg__c",
            width: 90,
            height: 240,
            x: 165,
            y: 90,
            rx: 45
          }
        )
      ] }),
      /* @__PURE__ */ e("g", { fill: "none", fillRule: "evenodd", children: [
        /* @__PURE__ */ o(
          "path",
          {
            fill: "url(#one-colored_svg__a)",
            d: "M210 420c115.98 0 210-94.02 210-210S325.98 0 210 0 0 94.02 0 210s94.02 210 210 210"
          }
        ),
        /* @__PURE__ */ o(
          "use",
          {
            xlinkHref: "#one-colored_svg__c",
            fill: "currentcolor",
            filter: "url(#one-colored_svg__b)"
          }
        ),
        /* @__PURE__ */ o("use", { xlinkHref: "#one-colored_svg__c", fill: "url(#one-colored_svg__d)" }),
        /* @__PURE__ */ o(
          "use",
          {
            xlinkHref: "#one-colored_svg__c",
            fill: "currentcolor",
            filter: "url(#one-colored_svg__e)"
          }
        ),
        /* @__PURE__ */ o(
          "path",
          {
            fill: "url(#one-colored_svg__f)",
            d: "M210 157c13.807 0 25-11.193 25-25s-11.193-25-25-25-25 11.193-25 25 11.193 25 25 25",
            opacity: 0.74
          }
        )
      ] })
    ]
  }
);
export {
  s as default
};
